<template>
  <div id="marker-summary-journal-tab" class="container-fluid mb-5 step-content">
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <h2 class="title mr-3">Call Journal</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-3">
        <table
          v-if="callJournal.length > 0"
          class="table amb-vue-table amb-whitebg-vue-table table-hover-rows"
        >
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">Phone</th>
              <th scope="col">Date</th>
              <th scope="col">Start Time</th>
              <th scope="col">End Time</th>
              <th scope="col">Duration</th>
              <th scope="col">Broker Ext.</th>
              <th scope="col"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(journal, index) in callJournal" :key="journal.id">
              <td>
                <p class="mb-0"><span :class="callType(journal.call_type)"></span></p>
              </td>
              <td>
                <p class="mb-0">{{journal.phone}}</p>
              </td>
              <td>
                <p
                  class="mb-0"
                >{{  journal.date_time | moment('timezone', $store.getters.timezone , "M/D/YYYY  h:mm a") }}</p>
              </td>
              <td>
                <p class="mb-0">{{ journal.call_start | moment('timezone', $store.getters.timezone , 'M/D/YYYY h:mm:ss a') }}</p>
              </td>
              <td>
                <p class="mb-0">{{ journal.call_end | moment('timezone', $store.getters.timezone , 'M/D/YYYY h:mm:ss a') }}</p>
              </td>
              <td>
                <p class="mb-0">{{ JSON.parse(journal.duration).total }}</p>
              </td>
              <td>
                <p class="mb-0">{{journal.agent}}</p>
              </td>

              <td class="text-right">
                <button
                  class="amb-icon-btn"
                  type="button"
                  v-tooltip:top="'Listen to recording'"
                  data-toggle="modal"
                  data-target="#play-recording"
                  @click="playRecording(journal.id, index)"
                >
                  <i class="mdi mdi-play-circle-outline"></i>
                </button>

                <button
                  v-tooltip:top="'Add task'"
                  class="amb-icon-btn"
                  @click="addTask(journal.id, index)"
                >
                  <i class="fas fa-tasks fa-lg"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>No call logs</div>
      </div>
    </div>


    <x-modal width="600" @close="player.visible = false"  v-if="player.visible == true" :footer="false">
      <div slot="title" :class="`truncate`">
          Play Call Recording
      </div>
      <vue-audio
          :autoplay="player.autoplay"
          :formats="player.formats"
          :src="player.src"
          :key="player.id"
          :preload="player.preload"
          :xhrWithCredentials="player.credentials"
          :html5="player.html5"
      ></vue-audio>
    </x-modal>

    <application-modal v-if="modal.visible == true">
      <div class="amb-modal-header py-1 d-flex justify-content-between">
        <div class="d-flex px-3 align-items-center">
          <h3 class="modal-title mb-0 mr-3 text-white">Add Task</h3>
        </div>
        <div class="p-3 amb-close-modal" v-on:click="modal.visible = false">
          <i class="fas fa-lg fa-times text-white"></i>
        </div>
      </div>

      <div class="container">
        <div class="row pt-0 amb-modal-body">
          <div class="col-12 mb-3">
            <div class="input-belt mb-3">
              <application-input
                class="input-belt flex-fill mb-3 mt-2"
                v-model="modal.taskName"
              >Name</application-input>
            </div>

            <div class="row">
              <div class="col-6 mb-2 input-belt">
                <el-date-picker
                  v-model="modal.remindMe"
                  type="date"
                  placeholder="Remind me"
                  format="dd/MM/yyyy"
                ></el-date-picker>
                <!-- TODO send documents required to vuex  -->
              </div>

              <div class="col-6 mb-2 input-belt">
                <el-time-picker
                  v-model="modal.time"
                  format="HH:mm"
                  value-format="HH:mm"
                  :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59'
                        }"
                  placeholder="Due Date Time"
                ></el-time-picker>
              </div>
            </div>

            <button
              class="col-12 my-3 btn-green w-100"
              @click="addTaskFromCall(modal.selectedCall.application_id)"
            >Add Task</button>
          </div>
        </div>
      </div>
    </application-modal>
  </div>
</template>


<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      callJournal: '',
      modal: {
        selectedCall: null,
        taskName: "",
        remindMe: "",
        time: "17:00",
        visible: false
      },
      player: {
        selectedRecording: null,
        autoplay: true,
        formats: [],
        preload: false,
        credentials: true,
        html5: true,
        id: 0,
        src: '',
        visible: false,
        title: ''
      }
    };
  },
  mounted(){
    axios
    .get("/api/application/" + applicationId + "/journal", this.apiToken())
    .then(res => {
      this.callJournal = res.data.journals
    })
    .catch(err => {
      console.error(err);
    });
  },
  methods: {
    apiToken() {
      return {
        headers: { Authorization: "Bearer " + this.$store.getters.token }
      };
    },
    addTask(id, index) {
      this.modal.selectedCall = this.callJournal[index];
      this.modal.taskName =
        "Call Follow Up - " + this.modal.selectedCall.phone + ' Regarding application #' + this.modal.selectedCall.application_id;
      this.modal.visible = true;
    },
    playRecording(id, index) {
      this.player.selectedRecording = this.callJournal[index];
      axios
        .post(
          "/api/pbx/recording",{
            agent: this.player.selectedRecording.agent,
            phone: this.player.selectedRecording.phone,
            duration: this.player.selectedRecording.duration,
            date_time: this.player.selectedRecording.date_time
          },
          this.apiToken()
        )
        .then (res => {
          this.player.id = id;
          this.player.src = res.data;
          this.player.visible = true;
        })
        .catch(err => {
          Message({
            message: "Recording Not Available, please try again later.",
            type: "error"
          });
        });
    },
    addTaskFromCall(id) {
      axios
        .post(
          "/api/application/" + id + "/journal/task",
          {
            application_id: id,
            task_name: this.modal.taskName ? this.modal.taskName : null,
            time: this.modal.time,
            due_date: this.modal.remindMe
          },
          this.apiToken()
        )
        .then(res => {
          this.modal.visible = false;
          Message({
            message: "Task Added",
            type: "success"
          });
        })
        .catch(err => {
          console.error(err);
          Message({
            message: "Cannot Add Task",
            type: "error"
          });
        });
    },
    callType(type) {
      return 'mdi mdi-phone-' + type;
    }
  }
};
</script>

<style scoped>
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all 0.8s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
<style lang="scss">
    .mdi {
      .mdi-phone-incoming {
          color: #27a744;
      }
      .mdi-phone-outgoing {
          color: #27a744;
      }
      .mdi-phone-missed {
          color: #f9081f;
      }
    }
    .truncate {
        max-width: 450px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .vueAudioBetter {
        background-image: none!important;
        box-shadow: none!important;
        background-color: #ffffff!important;

        .total {
            justify-content: center;
            span:nth-child(2){
                display: none;
            }
        }

        .icon-speed-1,
        .icon-subtract_fill,
        .icon-roundaddfill {
            display: none!important;
        }

        .operatorButton span {
            cursor: pointer;
            width: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>
